// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__qKaoU"};